export default {

    state: {
        underwriters: [],
        chiResources: {},
        chiResourcesKey: null,
        aiicoResources: {},
        policy: {}
    },
    mutations: {
        setVehicleUnderwriters(state, payload){
            state.plans = payload
        },
        setChiVehicleResources(state, val){
            if (val && typeof val === 'object' && Object.prototype.hasOwnProperty.call(val, 'data')) {
                state.chiResources = val.data
                state.chiResourcesKey = val.key ?? null
                return
            }
            state.chiResources = val
            state.chiResourcesKey = null
        },
        setAiicoVehicleResources(state, val){
            state.aiicoResources = val
        },
        setVehiclePolicy(state, obj){
            state.policy = obj
        }
    },
    actions: {},

}
